<template>
    <img src="/images/logo.svg" alt="logo">
</template>
